import { isVisible, slideDown, slideUp } from 'slide-anim';

export const slideNextHandler = async (el) => {
    // When the element is animating, we don't want to trigger the animation again.
    if (el.dataset?.isAnimating === 'true') return;

    const item = el.parentNode.nextElementSibling;

    // Set the element to be animating.
    el.dataset.isAnimating = 'true';

    if (isVisible(item)) {
        el.setAttribute('aria-expanded', false);
        await slideUp(item);
    } else {
        el.setAttribute('aria-expanded', true);
        await slideDown(item);
    }

    // When the animation is done, we set the element to not be animating. The button is now ready to be clicked again.
    el.dataset.isAnimating = 'false';
};
